// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import _, { get, merge, find } from 'lodash';
import { push } from 'react-router-redux';
import phoneify from 'phoneify';

import InfoIcon from '../../../../common/svgs/InfoIcon';
import CloseX from '../../../../common/svgs/CloseX';

export default class UserAlert extends Component {
  static propTypes = {
    onSelect: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    alert: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
    selected: PropTypes.number,
  }


  navigateAlert(alert, target) {
    let path = `/admin`;
    if (target == 'user') {
      path = path + `/${alert.alertData.location || alert.alertData.locationName}/${alert.alertData.target}/details`;
    }
    else if (target == 'location') {
      path = path + `/${alert.alertData.location || alert.alertData.locationName}`;
    }

    this.props.dispatch(push(path));
  }

  render() {

      const alert = this.props.alert;

      return(

        <div className={`user-alert ${this.props.selected == alert.id ? '' : 'inactive'}`} key={alert.id} data-id={`alert-${alert.id}`} onClick={() => this.props.onSelect(alert)}>
          <div className='left-side'>
            <InfoIcon color={alert.isRead ? '#777777' : ''} />
            <div className='user-alert-message'>
              <span className='notification-link' onClick={(event) => this.navigateAlert(alert, 'user')}>{alert.alertData.name}</span>
              &nbsp;{alert.alertData.actionLong || alert.alertData.action}&nbsp;
              <span className='notification-link' onClick={(event) => this.navigateAlert(alert, 'location')} >{alert.alertData.locationName ? alert.alertData.locationName : alert.alertData.location || ''}</span>
            </div>
          </div>
          <CloseX className='dismiss-button' onClick={(e) => this.props.onClose(e, alert.id)} />
        </div>

      );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Alerts/UserAlert/index.js